
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account-access",
      function () {
        return require("private-next-pages/account-access/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account-access"])
      });
    }
  